// extracted by mini-css-extract-plugin
module.exports = {"widgetRow":"_c0185aa"};